import { render } from "./mobileMrecAd.vue?vue&type=template&id=18cacad6&scoped=true"
import script from "./mobileMrecAd.vue?vue&type=script&lang=js"
export * from "./mobileMrecAd.vue?vue&type=script&lang=js"

import "./mobileMrecAd.vue?vue&type=style&index=0&id=18cacad6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18cacad6"]])

export default __exports__